// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #595959; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}

* {
  scrollbar-color: initial;
  scrollbar-width: initial;
}
.container {
  width: 100%;
}
@media (min-width: 300px) {

  .container {
    max-width: 300px;
  }
}
@media (min-width: 400px) {

  .container {
    max-width: 400px;
  }
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1220px) {

  .container {
    max-width: 1220px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1354px) {

  .container {
    max-width: 1354px;
  }
}
@media (min-width: 1512px) {

  .container {
    max-width: 1512px;
  }
}
@media (min-width: 1656px) {

  .container {
    max-width: 1656px;
  }
}
@media (min-width: 1800px) {

  .container {
    max-width: 1800px;
  }
}
@media (min-width: 1920px) {

  .container {
    max-width: 1920px;
  }
}
.pointer-events-none {
  pointer-events: none;
}
.visible {
  visibility: visible;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.inset-0 {
  inset: 0px;
}
.-bottom-5 {
  bottom: -20px;
}
.-bottom-6 {
  bottom: -24px;
}
.bottom-0 {
  bottom: 0px;
}
.left-0 {
  left: 0px;
}
.left-20 {
  left: 136px;
}
.right-0 {
  right: 0px;
}
.right-7 {
  right: 32px;
}
.top-0 {
  top: 0px;
}
.top-6 {
  top: 24px;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-30 {
  z-index: 30;
}
.z-50 {
  z-index: 50;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.-ml-6 {
  margin-left: -24px;
}
.-mr-1 {
  margin-right: -4px;
}
.mb-10 {
  margin-bottom: 56px;
}
.mb-2 {
  margin-bottom: 8px;
}
.mb-4 {
  margin-bottom: 16px;
}
.mb-6 {
  margin-bottom: 24px;
}
.mb-8 {
  margin-bottom: 40px;
}
.ml-1 {
  margin-left: 4px;
}
.ml-2 {
  margin-left: 8px;
}
.ml-\\[15px\\] {
  margin-left: 15px;
}
.mr-2 {
  margin-right: 8px;
}
.mt-0 {
  margin-top: 0px;
}
.mt-1 {
  margin-top: 4px;
}
.mt-14 {
  margin-top: 88px;
}
.mt-2 {
  margin-top: 8px;
}
.mt-4 {
  margin-top: 16px;
}
.mt-5 {
  margin-top: 20px;
}
.inline-block {
  display: inline-block;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.\\!h-11 {
  height: 64px !important;
}
.h-10 {
  height: 56px;
}
.h-11 {
  height: 64px;
}
.h-5 {
  height: 20px;
}
.h-7 {
  height: 32px;
}
.h-8 {
  height: 40px;
}
.h-\\[296px\\] {
  height: 296px;
}
.h-\\[64px\\] {
  height: 64px;
}
.h-full {
  height: 100%;
}
.max-h-\\[350px\\] {
  max-height: 350px;
}
.max-h-\\[calc\\(100vh-100px\\)\\] {
  max-height: calc(100vh - 100px);
}
.w-16 {
  width: 104px;
}
.w-5 {
  width: 20px;
}
.w-6 {
  width: 24px;
}
.w-7 {
  width: 32px;
}
.w-8 {
  width: 40px;
}
.w-\\[148px\\] {
  width: 148px;
}
.w-\\[20\\%\\] {
  width: 20%;
}
.w-\\[200px\\] {
  width: 200px;
}
.w-\\[272px\\] {
  width: 272px;
}
.w-\\[280px\\] {
  width: 280px;
}
.w-\\[90\\%\\] {
  width: 90%;
}
.w-fit {
  width: fit-content;
}
.w-full {
  width: 100%;
}
.max-w-fit {
  max-width: fit-content;
}
.shrink-0 {
  flex-shrink: 0;
}
.flex-grow {
  flex-grow: 1;
}
.translate-y-0 {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-20 {
  --tw-translate-y: 136px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-0 {
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-7 {
  grid-template-columns: repeat(7, minmax(0, 1fr));
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-around {
  justify-content: space-around;
}
.gap-2 {
  gap: 8px;
}
.gap-3 {
  gap: 12px;
}
.gap-4 {
  gap: 16px;
}
.gap-5 {
  gap: 20px;
}
.space-y-11 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(64px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(64px * var(--tw-space-y-reverse));
}
.self-center {
  align-self: center;
}
.overflow-auto {
  overflow: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-none {
  border-radius: 0px;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-l-lg {
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.rounded-l-xl {
  border-top-left-radius: 0.75rem;
  border-bottom-left-radius: 0.75rem;
}
.rounded-r-lg {
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}
.rounded-r-xl {
  border-top-right-radius: 0.75rem;
  border-bottom-right-radius: 0.75rem;
}
.border {
  border-width: 1px;
}
.border-2 {
  border-width: 2px;
}
.border-y {
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-none {
  border-style: none;
}
.border-\\[\\#999999\\] {
  --tw-border-opacity: 1;
  border-color: rgb(153 153 153 / var(--tw-border-opacity, 1));
}
.border-\\[\\#ff7020\\] {
  --tw-border-opacity: 1;
  border-color: rgb(255 112 32 / var(--tw-border-opacity, 1));
}
.border-gray {
  --tw-border-opacity: 1;
  border-color: rgb(154 145 135 / var(--tw-border-opacity, 1));
}
.border-gray-10 {
  --tw-border-opacity: 1;
  border-color: rgb(231 232 232 / var(--tw-border-opacity, 1));
}
.border-gray-20 {
  --tw-border-opacity: 1;
  border-color: rgb(208 209 210 / var(--tw-border-opacity, 1));
}
.border-orange-600 {
  --tw-border-opacity: 1;
  border-color: rgb(234 88 12 / var(--tw-border-opacity, 1));
}
.border-red-500 {
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.border-transparent {
  border-color: transparent;
}
.\\!bg-\\[\\#F2F2F2\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(242 242 242 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-\\[\\#ff7020\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 112 32 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#000\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FFF0CC\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 240 204 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#ded7d3\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(222 215 211 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f2f2f2\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(242 242 242 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#ff7020\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 112 32 / var(--tw-bg-opacity, 1));
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(30 30 30 / var(--tw-bg-opacity, 1));
}
.bg-orange-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(234 88 12 / var(--tw-bg-opacity, 1));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-opacity-50 {
  --tw-bg-opacity: 0.5;
}
.fill-black {
  fill: #1E1E1E;
}
.p-1 {
  padding: 4px;
}
.p-2 {
  padding: 8px;
}
.p-3 {
  padding: 12px;
}
.p-4 {
  padding: 16px;
}
.p-6 {
  padding: 24px;
}
.px-4 {
  padding-left: 16px;
  padding-right: 16px;
}
.px-7 {
  padding-left: 32px;
  padding-right: 32px;
}
.py-1 {
  padding-top: 4px;
  padding-bottom: 4px;
}
.py-2 {
  padding-top: 8px;
  padding-bottom: 8px;
}
.py-3 {
  padding-top: 12px;
  padding-bottom: 12px;
}
.py-6 {
  padding-top: 24px;
  padding-bottom: 24px;
}
.pt-\\[20\\%\\] {
  padding-top: 20%;
}
.pt-\\[5\\%\\] {
  padding-top: 5%;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-\\[12px\\] {
  font-size: 12px;
}
.text-\\[14px\\] {
  font-size: 14px;
}
.text-\\[16px\\] {
  font-size: 16px;
}
.text-\\[24px\\] {
  font-size: 24px;
}
.font-bold {
  font-weight: 700;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.\\!text-black {
  --tw-text-opacity: 1 !important;
  color: rgb(30 30 30 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#595959\\] {
  --tw-text-opacity: 1;
  color: rgb(89 89 89 / var(--tw-text-opacity, 1));
}
.text-\\[\\#666666\\] {
  --tw-text-opacity: 1;
  color: rgb(102 102 102 / var(--tw-text-opacity, 1));
}
.text-\\[\\#7C3A00\\] {
  --tw-text-opacity: 1;
  color: rgb(124 58 0 / var(--tw-text-opacity, 1));
}
.text-\\[\\#999\\] {
  --tw-text-opacity: 1;
  color: rgb(153 153 153 / var(--tw-text-opacity, 1));
}
.text-\\[\\#ff7020\\] {
  --tw-text-opacity: 1;
  color: rgb(255 112 32 / var(--tw-text-opacity, 1));
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(30 30 30 / var(--tw-text-opacity, 1));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-orange-600 {
  --tw-text-opacity: 1;
  color: rgb(234 88 12 / var(--tw-text-opacity, 1));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.line-through {
  text-decoration-line: line-through;
}
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-shadow {
  transition-property: box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.scrollbar-hide {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.scrollbar-hide::-webkit-scrollbar {
  display: none;
}
.scrollbar-thin::-webkit-scrollbar-track {
  background-color: var(--scrollbar-track);
  border-radius: var(--scrollbar-track-radius);
}
.scrollbar-thin::-webkit-scrollbar-track:hover {
  background-color: var(--scrollbar-track-hover, var(--scrollbar-track));
}
.scrollbar-thin::-webkit-scrollbar-track:active {
  background-color: var(--scrollbar-track-active, var(--scrollbar-track-hover, var(--scrollbar-track)));
}
.scrollbar-thin::-webkit-scrollbar-thumb {
  background-color: var(--scrollbar-thumb);
  border-radius: var(--scrollbar-thumb-radius);
}
.scrollbar-thin::-webkit-scrollbar-thumb:hover {
  background-color: var(--scrollbar-thumb-hover, var(--scrollbar-thumb));
}
.scrollbar-thin::-webkit-scrollbar-thumb:active {
  background-color: var(--scrollbar-thumb-active, var(--scrollbar-thumb-hover, var(--scrollbar-thumb)));
}
.scrollbar-thin::-webkit-scrollbar-corner {
  background-color: var(--scrollbar-corner);
  border-radius: var(--scrollbar-corner-radius);
}
.scrollbar-thin::-webkit-scrollbar-corner:hover {
  background-color: var(--scrollbar-corner-hover, var(--scrollbar-corner));
}
.scrollbar-thin::-webkit-scrollbar-corner:active {
  background-color: var(--scrollbar-corner-active, var(--scrollbar-corner-hover, var(--scrollbar-corner)));
}
.scrollbar-thin {
  scrollbar-width: thin;
  scrollbar-color: var(--scrollbar-thumb, initial) var(--scrollbar-track, initial);
}
.scrollbar-thin::-webkit-scrollbar {
  display: block;
  width: 8px;
  height: 8px;
}
.scrollbar-track-white {
  --scrollbar-track: #FFFFFF !important;
}
.scrollbar-thumb-black {
  --scrollbar-thumb: #1E1E1E !important;
}
.placeholder\\:font-semibold::placeholder {
  font-weight: 600;
}
.placeholder\\:text-\\[\\#59595959\\]::placeholder {
  color: #59595959;
}
.placeholder\\:text-black::placeholder {
  --tw-text-opacity: 1;
  color: rgb(30 30 30 / var(--tw-text-opacity, 1));
}
.hover\\:border:hover {
  border-width: 1px;
}
.hover\\:border-orange-600:hover {
  --tw-border-opacity: 1;
  border-color: rgb(234 88 12 / var(--tw-border-opacity, 1));
}
.hover\\:border-orange-700:hover {
  --tw-border-opacity: 1;
  border-color: rgb(194 65 12 / var(--tw-border-opacity, 1));
}
.hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(218 208 197 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.focus\\:border-orange-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(249 115 22 / var(--tw-border-opacity, 1));
}
.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.active\\:border:active {
  border-width: 1px;
}
.active\\:bg-black:active {
  --tw-bg-opacity: 1;
  background-color: rgb(30 30 30 / var(--tw-bg-opacity, 1));
}
.active\\:text-white:active {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.disabled\\:bg-\\[\\#F2F2F2\\]:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(242 242 242 / var(--tw-bg-opacity, 1));
}
.disabled\\:bg-gray:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(154 145 135 / var(--tw-bg-opacity, 1));
}
@media (min-width: 640px) {

  .sm\\:flex-col {
    flex-direction: column;
  }

  .sm\\:self-end {
    align-self: flex-end;
  }
}
@media (min-width: 768px) {

  .md\\:ml-7 {
    margin-left: 32px;
  }
}
@media (min-width: 1024px) {

  .lg\\:flex-row {
    flex-direction: row;
  }

  .lg\\:self-center {
    align-self: center;
  }
}
@media (min-width: 1280px) {

  .xl\\:ml-0 {
    margin-left: 0px;
  }
}

/* Estilos para .ant-select */
.ant-select-selector {
  width: 270px;
  height: 64px;
  transition: border-color 0.3s;
  border-radius: 8px;
  border: 1.5px solid #999999 !important;
  box-shadow: none;
  outline: none;
}

.ant-select-selector:hover {
  border: 1.5px solid #EA580C !important;
}

.ant-select-selector:focus-within {
  border: 1.5px solid #EA580C !important;
}

.ant-select-status-error .ant-select-selector {
  border: 2px solid red !important;
}

/* Estilos para .ant-picker */
.ant-picker.ant-picker-outlined.css-dev-only-do-not-override-apn68.ant-picker {
  border: 2px solid transparent !important;
  height: 64px !important;
  width: auto;
  border-radius: 8px !important;
  transition: border-color 0.3s;
  outline: none;
}

.ant-picker.ant-picker-range.ant-picker-outlined.css-dev-only-do-not-override-apn68 .ant-picker {
  border: transparent !important;
  outline: none;
}

.ant-picker.ant-picker-range.ant-picker-outlined.css-dev-only-do-not-override-apn68.ant-picker:focus-within {
  border: transparent !important;
  outline: none;
}

.ant-picker.ant-picker-rangeant-picker-outlined.css-dev-only-do-not-override-apn68.ant-picker:hover,
.ant-select-selector:focus,
.ant-picker.ant-picker-outlined.css-dev-only-do-not-override-apn68.ant-picker:focus {
  border: 2px solid #EA580C !important;
}

.ant-picker-range-separator .anticon-swap-right svg {
  display: none !important;
}

.ant-picker-active-bar {
  display: none;
}

/* Estilos para .ant-picker com erro */
.ant-picker-status-error {
  border-color: red !important;
}

/* Estilos para o botão de pesquisa personalizado */
.custom-search-button {
  background-color: #EA580C;
  color: white;
  height: 48px;
  padding: 0 16px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s;
}

.custom-search-button:hover {
  background-color: #cc4c0a;
}

/* Estilos de células do calendário */
.ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner,
.ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner {
  background-color: #000000 !important;
  width: 39px;
  height: 38px;
  border-radius: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ant-picker-cell-in-view.ant-picker-cell-today .ant-picker-cell-inner::before {
  border-color: #EA580C !important;
  border-radius: 14px !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  text-align: center !important;
}

.ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single)::before,
.ant-picker-cell-in-view.ant-picker-cell-in-range::before,
.ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single)::before {
  background: rgb(245, 245, 245) !important;
  width: 40px;
  height: 38px;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Estilos para o painel de hora */
.ant-picker-time-panel-column li.ant-picker-time-panel-cell-selected .ant-picker-time-panel-cell-inner {
  background: rgb(245, 245, 245) !important;
  width: 40px;
  height: 38px;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Estilos para o campo de entrada de data */

.custom-rangepicker .ant-picker-input {
  border: 2.5px solid #999999;
  border-radius: 8px;
  height: 66px;
  width: 160px !important;
  padding: 20px;
  transition: border-color 0.3s ease;
}

.custom-rangepicker.error .ant-picker-input {
  border-color: #ef4444 !important; /* Cor da borda em caso de erro */
}


@media (max-width: 1024px) {
  .ant-picker-input {
    width: 270px !important;
    margin-left: -15px;
  }
}

.ant-picker-input:hover {
  border: 2.5px solid #EA580C !important;
}

.ant-picker-input:hover:where(.css-dev-only-do-not-override-apn68).ant-picker-outlined:focus,
:where(.css-dev-only-do-not-override-1x0dypw).ant-picker-outlined:focus, :where(.css-dev-only-do-not-override-1x0dypw).ant-picker-outlined:focus-within {
  border-color: transparent !important;
  box-shadow: none !important;
}
:where(.css-dev-only-do-not-override-apn68).ant-picker-outlined:focus-within {
  box-shadow: none !important;
  border: 2.5px solid #EA580C !important;
}

.ant-select-selection-placeholder,
.ant-picker-input input::placeholder {
  color: #6B7280 !important;
}

.ant-picker .ant-picker-range .ant-picker-outlined .css-dev-only-do-not-override-apn68 .ant-picker {
  border: 2px solid transparent !important;
  outline: none;
}

.ant-picker.ant-picker-range.ant-picker-outlined.css-dev-only-do-not-override-apn68.ant-picker:focus-within {
  border: 2px solid transparent !important;
  outline: none;
}

:where(.css-dev-only-do-not-override-1x0dypw).ant-picker-range .ant-picker-range-separator {
  padding: 0px 0px;
}

:where(.css-dev-only-do-not-override-1wwf28x).ant-picker-range .ant-picker-range-separator{
  padding: 0px 0px;
}

:where(.css-dev-only-do-not-override-1wwf28x).ant-picker-outlined:focus, :where(.css-dev-only-do-not-override-1wwf28x).ant-picker-outlined:focus-within {
  box-shadow: none !important;
}
.ant-picker-range-separator .anticon-swap-right svg {
  display: none !important;
  padding: 0px 0px;
}

:where(.css-dev-only-do-not-override-tpassh).ant-picker-range .ant-picker-range-separator{
  padding: 0px 0px;
  width: 10px;
  @media (max-width: 1024px) {
    padding: 0px 6px;
  }
}

.ant-picker-active-bar {
  display: none;
}

.ant-picker .ant-picker-range .ant-picker-outlined .css-dev-only-do-not-override-apn68 .ant-picker {
  border: none !important;
  outline: none;
}

/* Estilos para a entrada de data com erro */
.ant-picker-status-error {
  border-color: red !important;
}

div[class*="ant-picker-range"] {
  background: transparent;
  border-width: 0;
  border-color: transparent;

  @media (max-width: 1024px) {
    margin-left: 3px;
    gap: 10px;
  }
}

:where(.css-dev-only-do-not-override-tpassh).ant-picker-outlined:focus,
:where(.css-dev-only-do-not-override-tpassh).ant-picker-outlined:focus-within {
  background-color: transparent;
  border-color: transparent;
  box-shadow: 0 0 2px rgba(255, 255, 255, 0.5);
  outline: 0;
}
:where(.css-dev-only-do-not-override-1wwf28x).ant-select-dropdown .ant-select-item {
  height: 50px !important;
  cursor: pointer !important;
}

button.disabled{
  cursor: not-allowed !important;
  color: gray;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@smiles-viagens/sviagens-react-package-search/lib/components/Desktop/main.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;EACf,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,sCAAsC;EACtC,8BAA8B;EAC9B,6BAA6B;EAC7B,4BAA4B;EAC5B,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;EAC5B,sCAAsC;EACtC,kCAAkC;EAClC,2BAA2B;EAC3B,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;EACf,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,sCAAsC;EACtC,8BAA8B;EAC9B,6BAA6B;EAC7B,4BAA4B;EAC5B,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;EAC5B,sCAAsC;EACtC,kCAAkC;EAClC,2BAA2B;EAC3B,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;AACvB,CAAC;;CAEA,CAAC;;;CAGD;;AAED;;;EAGE,sBAAsB,EAAE,MAAM;EAC9B,eAAe,EAAE,MAAM;EACvB,mBAAmB,EAAE,MAAM;EAC3B,qBAAqB,EAAE,MAAM;AAC/B;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;;;;;;;CAQC;;AAED;;EAEE,gBAAgB,EAAE,MAAM;EACxB,8BAA8B,EAAE,MAAM,EAAE,MAAM;EAC9C,WAAW,EAAE,MAAM;EACnB,+HAA+H,EAAE,MAAM;EACvI,6BAA6B,EAAE,MAAM;EACrC,+BAA+B,EAAE,MAAM;EACvC,wCAAwC,EAAE,MAAM;AAClD;;AAEA;;;CAGC;;AAED;EACE,SAAS,EAAE,MAAM;EACjB,oBAAoB,EAAE,MAAM;AAC9B;;AAEA;;;;CAIC;;AAED;EACE,SAAS,EAAE,MAAM;EACjB,cAAc,EAAE,MAAM;EACtB,qBAAqB,EAAE,MAAM;AAC/B;;AAEA;;CAEC;;AAED;EACE,yCAAyC;UACjC,iCAAiC;AAC3C;;AAEA;;CAEC;;AAED;;;;;;EAME,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;CAEC;;AAED;EACE,cAAc;EACd,wBAAwB;AAC1B;;AAEA;;CAEC;;AAED;;EAEE,mBAAmB;AACrB;;AAEA;;;;;CAKC;;AAED;;;;EAIE,+GAA+G,EAAE,MAAM;EACvH,6BAA6B,EAAE,MAAM;EACrC,+BAA+B,EAAE,MAAM;EACvC,cAAc,EAAE,MAAM;AACxB;;AAEA;;CAEC;;AAED;EACE,cAAc;AAChB;;AAEA;;CAEC;;AAED;;EAEE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;;;;CAIC;;AAED;EACE,cAAc,EAAE,MAAM;EACtB,qBAAqB,EAAE,MAAM;EAC7B,yBAAyB,EAAE,MAAM;AACnC;;AAEA;;;;CAIC;;AAED;;;;;EAKE,oBAAoB,EAAE,MAAM;EAC5B,8BAA8B,EAAE,MAAM;EACtC,gCAAgC,EAAE,MAAM;EACxC,eAAe,EAAE,MAAM;EACvB,oBAAoB,EAAE,MAAM;EAC5B,oBAAoB,EAAE,MAAM;EAC5B,uBAAuB,EAAE,MAAM;EAC/B,cAAc,EAAE,MAAM;EACtB,SAAS,EAAE,MAAM;EACjB,UAAU,EAAE,MAAM;AACpB;;AAEA;;CAEC;;AAED;;EAEE,oBAAoB;AACtB;;AAEA;;;CAGC;;AAED;;;;EAIE,0BAA0B,EAAE,MAAM;EAClC,6BAA6B,EAAE,MAAM;EACrC,sBAAsB,EAAE,MAAM;AAChC;;AAEA;;CAEC;;AAED;EACE,aAAa;AACf;;AAEA;;CAEC;;AAED;EACE,gBAAgB;AAClB;;AAEA;;CAEC;;AAED;EACE,wBAAwB;AAC1B;;AAEA;;CAEC;;AAED;;EAEE,YAAY;AACd;;AAEA;;;CAGC;;AAED;EACE,6BAA6B,EAAE,MAAM;EACrC,oBAAoB,EAAE,MAAM;AAC9B;;AAEA;;CAEC;;AAED;EACE,wBAAwB;AAC1B;;AAEA;;;CAGC;;AAED;EACE,0BAA0B,EAAE,MAAM;EAClC,aAAa,EAAE,MAAM;AACvB;;AAEA;;CAEC;;AAED;EACE,kBAAkB;AACpB;;AAEA;;CAEC;;AAED;;;;;;;;;;;;;EAaE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;;;EAGE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;;CAEC;AACD;EACE,UAAU;AACZ;;AAEA;;CAEC;;AAED;EACE,gBAAgB;AAClB;;AAEA;;;CAGC;;AAED;;EAEE,UAAU,EAAE,MAAM;EAClB,cAAc,EAAE,MAAM;AACxB;;AAEA;;CAEC;;AAED;;EAEE,eAAe;AACjB;;AAEA;;CAEC;AACD;EACE,eAAe;AACjB;;AAEA;;;;CAIC;;AAED;;;;;;;;EAQE,cAAc,EAAE,MAAM;EACtB,sBAAsB,EAAE,MAAM;AAChC;;AAEA;;CAEC;;AAED;;EAEE,eAAe;EACf,YAAY;AACd;;AAEA,wEAAwE;AACxE;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;AAC1B;AACA;EACE,WAAW;AACb;AACA;;EAEE;IACE,gBAAgB;EAClB;AACF;AACA;;EAEE;IACE,gBAAgB;EAClB;AACF;AACA;;EAEE;IACE,gBAAgB;EAClB;AACF;AACA;;EAEE;IACE,gBAAgB;EAClB;AACF;AACA;;EAEE;IACE,iBAAiB;EACnB;AACF;AACA;;EAEE;IACE,iBAAiB;EACnB;AACF;AACA;;EAEE;IACE,iBAAiB;EACnB;AACF;AACA;;EAEE;IACE,iBAAiB;EACnB;AACF;AACA;;EAEE;IACE,iBAAiB;EACnB;AACF;AACA;;EAEE;IACE,iBAAiB;EACnB;AACF;AACA;;EAEE;IACE,iBAAiB;EACnB;AACF;AACA;;EAEE;IACE,iBAAiB;EACnB;AACF;AACA;EACE,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,SAAS;AACX;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,QAAQ;AACV;AACA;EACE,SAAS;AACX;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,oBAAoB;AACtB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,uBAAuB;AACzB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,+LAA+L;AACjM;AACA;EACE,uBAAuB;EACvB,+LAA+L;AACjM;AACA;EACE,iBAAiB;EACjB,+LAA+L;AACjM;AACA;EACE,mBAAmB;EACnB,+LAA+L;AACjM;AACA;EACE,+LAA+L;AACjM;AACA;;EAEE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,kCAAkC;AACpC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,QAAQ;AACV;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,uBAAuB;EACvB,4DAA4D;EAC5D,qDAAqD;AACvD;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;AACA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;AACA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;AACA;EACE,gCAAgC;EAChC,mCAAmC;AACrC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,4DAA4D;AAC9D;AACA;EACE,sBAAsB;EACtB,2DAA2D;AAC7D;AACA;EACE,sBAAsB;EACtB,4DAA4D;AAC9D;AACA;EACE,sBAAsB;EACtB,4DAA4D;AAC9D;AACA;EACE,sBAAsB;EACtB,4DAA4D;AAC9D;AACA;EACE,sBAAsB;EACtB,0DAA0D;AAC5D;AACA;EACE,sBAAsB;EACtB,0DAA0D;AAC5D;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,6BAA6B;EAC7B,uEAAuE;AACzE;AACA;EACE,6BAA6B;EAC7B,sEAAsE;AACxE;AACA;EACE,kBAAkB;EAClB,sDAAsD;AACxD;AACA;EACE,kBAAkB;EAClB,4DAA4D;AAC9D;AACA;EACE,kBAAkB;EAClB,4DAA4D;AAC9D;AACA;EACE,kBAAkB;EAClB,4DAA4D;AAC9D;AACA;EACE,kBAAkB;EAClB,2DAA2D;AAC7D;AACA;EACE,kBAAkB;EAClB,yDAAyD;AAC3D;AACA;EACE,kBAAkB;EAClB,0DAA0D;AAC5D;AACA;EACE,kBAAkB;EAClB,4DAA4D;AAC9D;AACA;EACE,oBAAoB;AACtB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,+BAA+B;EAC/B,2DAA2D;AAC7D;AACA;EACE,oBAAoB;EACpB,gDAAgD;AAClD;AACA;EACE,oBAAoB;EACpB,mDAAmD;AACrD;AACA;EACE,oBAAoB;EACpB,gDAAgD;AAClD;AACA;EACE,oBAAoB;EACpB,mDAAmD;AACrD;AACA;EACE,oBAAoB;EACpB,kDAAkD;AACpD;AACA;EACE,oBAAoB;EACpB,gDAAgD;AAClD;AACA;EACE,oBAAoB;EACpB,mDAAmD;AACrD;AACA;EACE,oBAAoB;EACpB,gDAAgD;AAClD;AACA;EACE,oBAAoB;EACpB,iDAAiD;AACnD;AACA;EACE,oBAAoB;EACpB,iDAAiD;AACnD;AACA;EACE,oBAAoB;EACpB,mDAAmD;AACrD;AACA;EACE,kCAAkC;AACpC;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,gDAAgD;EAChD,6DAA6D;EAC7D,uGAAuG;AACzG;AACA;EACE,+EAA+E;EAC/E,mGAAmG;EACnG,uGAAuG;AACzG;AACA;EACE,gFAAgF;EAChF,oGAAoG;EACpG,uGAAuG;AACzG;AACA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,iLAAiL;AACnL;AACA;EACE,wBAAwB;EACxB,wDAAwD;EACxD,0BAA0B;AAC5B;AACA;EACE,4BAA4B;EAC5B,wDAAwD;EACxD,0BAA0B;AAC5B;AACA;EACE,+BAA+B;EAC/B,wDAAwD;EACxD,0BAA0B;AAC5B;AACA;EACE,8BAA8B;EAC9B,wDAAwD;EACxD,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,wDAAwD;AAC1D;AACA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,wCAAwC;EACxC,4CAA4C;AAC9C;AACA;EACE,sEAAsE;AACxE;AACA;EACE,qGAAqG;AACvG;AACA;EACE,wCAAwC;EACxC,4CAA4C;AAC9C;AACA;EACE,sEAAsE;AACxE;AACA;EACE,qGAAqG;AACvG;AACA;EACE,yCAAyC;EACzC,6CAA6C;AAC/C;AACA;EACE,wEAAwE;AAC1E;AACA;EACE,wGAAwG;AAC1G;AACA;EACE,qBAAqB;EACrB,gFAAgF;AAClF;AACA;EACE,cAAc;EACd,UAAU;EACV,WAAW;AACb;AACA;EACE,qCAAqC;AACvC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,gDAAgD;AAClD;AACA;EACE,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,0DAA0D;AAC5D;AACA;EACE,sBAAsB;EACtB,0DAA0D;AAC5D;AACA;EACE,kBAAkB;EAClB,4DAA4D;AAC9D;AACA;EACE,kBAAkB;EAClB,4DAA4D;AAC9D;AACA;EACE,sBAAsB;EACtB,2DAA2D;AAC7D;AACA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,yDAAyD;AAC3D;AACA;EACE,oBAAoB;EACpB,mDAAmD;AACrD;AACA;EACE,kBAAkB;EAClB,4DAA4D;AAC9D;AACA;EACE,kBAAkB;EAClB,4DAA4D;AAC9D;AACA;;EAEE;IACE,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;EACtB;AACF;AACA;;EAEE;IACE,iBAAiB;EACnB;AACF;AACA;;EAEE;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;AACF;AACA;;EAEE;IACE,gBAAgB;EAClB;AACF;;AAEA,6BAA6B;AAC7B;EACE,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,sCAAsC;EACtC,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,6BAA6B;AAC7B;EACE,wCAAwC;EACxC,uBAAuB;EACvB,WAAW;EACX,6BAA6B;EAC7B,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,aAAa;AACf;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA,sCAAsC;AACtC;EACE,4BAA4B;AAC9B;;AAEA,mDAAmD;AACnD;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,qCAAqC;AACrC;;EAEE,oCAAoC;EACpC,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;;;EAGE,yCAAyC;EACzC,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,yCAAyC;EACzC,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,4CAA4C;;AAE5C;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,gCAAgC,EAAE,iCAAiC;AACrE;;;AAGA;EACE;IACE,uBAAuB;IACvB,kBAAkB;EACpB;AACF;;AAEA;EACE,sCAAsC;AACxC;;AAEA;;EAEE,oCAAoC;EACpC,2BAA2B;AAC7B;AACA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,aAAa;AACf;;AAEA;EACE,wCAAwC;EACxC,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,aAAa;AACf;;AAEA,4CAA4C;AAC5C;EACE,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,yBAAyB;;EAEzB;IACE,gBAAgB;IAChB,SAAS;EACX;AACF;;AAEA;;EAEE,6BAA6B;EAC7B,yBAAyB;EACzB,4CAA4C;EAC5C,UAAU;AACZ;AACA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,WAAW;AACb","sourcesContent":["*, ::before, ::after {\n  --tw-border-spacing-x: 0;\n  --tw-border-spacing-y: 0;\n  --tw-translate-x: 0;\n  --tw-translate-y: 0;\n  --tw-rotate: 0;\n  --tw-skew-x: 0;\n  --tw-skew-y: 0;\n  --tw-scale-x: 1;\n  --tw-scale-y: 1;\n  --tw-pan-x:  ;\n  --tw-pan-y:  ;\n  --tw-pinch-zoom:  ;\n  --tw-scroll-snap-strictness: proximity;\n  --tw-gradient-from-position:  ;\n  --tw-gradient-via-position:  ;\n  --tw-gradient-to-position:  ;\n  --tw-ordinal:  ;\n  --tw-slashed-zero:  ;\n  --tw-numeric-figure:  ;\n  --tw-numeric-spacing:  ;\n  --tw-numeric-fraction:  ;\n  --tw-ring-inset:  ;\n  --tw-ring-offset-width: 0px;\n  --tw-ring-offset-color: #fff;\n  --tw-ring-color: rgb(59 130 246 / 0.5);\n  --tw-ring-offset-shadow: 0 0 #0000;\n  --tw-ring-shadow: 0 0 #0000;\n  --tw-shadow: 0 0 #0000;\n  --tw-shadow-colored: 0 0 #0000;\n  --tw-blur:  ;\n  --tw-brightness:  ;\n  --tw-contrast:  ;\n  --tw-grayscale:  ;\n  --tw-hue-rotate:  ;\n  --tw-invert:  ;\n  --tw-saturate:  ;\n  --tw-sepia:  ;\n  --tw-drop-shadow:  ;\n  --tw-backdrop-blur:  ;\n  --tw-backdrop-brightness:  ;\n  --tw-backdrop-contrast:  ;\n  --tw-backdrop-grayscale:  ;\n  --tw-backdrop-hue-rotate:  ;\n  --tw-backdrop-invert:  ;\n  --tw-backdrop-opacity:  ;\n  --tw-backdrop-saturate:  ;\n  --tw-backdrop-sepia:  ;\n  --tw-contain-size:  ;\n  --tw-contain-layout:  ;\n  --tw-contain-paint:  ;\n  --tw-contain-style:  ;\n}\n\n::backdrop {\n  --tw-border-spacing-x: 0;\n  --tw-border-spacing-y: 0;\n  --tw-translate-x: 0;\n  --tw-translate-y: 0;\n  --tw-rotate: 0;\n  --tw-skew-x: 0;\n  --tw-skew-y: 0;\n  --tw-scale-x: 1;\n  --tw-scale-y: 1;\n  --tw-pan-x:  ;\n  --tw-pan-y:  ;\n  --tw-pinch-zoom:  ;\n  --tw-scroll-snap-strictness: proximity;\n  --tw-gradient-from-position:  ;\n  --tw-gradient-via-position:  ;\n  --tw-gradient-to-position:  ;\n  --tw-ordinal:  ;\n  --tw-slashed-zero:  ;\n  --tw-numeric-figure:  ;\n  --tw-numeric-spacing:  ;\n  --tw-numeric-fraction:  ;\n  --tw-ring-inset:  ;\n  --tw-ring-offset-width: 0px;\n  --tw-ring-offset-color: #fff;\n  --tw-ring-color: rgb(59 130 246 / 0.5);\n  --tw-ring-offset-shadow: 0 0 #0000;\n  --tw-ring-shadow: 0 0 #0000;\n  --tw-shadow: 0 0 #0000;\n  --tw-shadow-colored: 0 0 #0000;\n  --tw-blur:  ;\n  --tw-brightness:  ;\n  --tw-contrast:  ;\n  --tw-grayscale:  ;\n  --tw-hue-rotate:  ;\n  --tw-invert:  ;\n  --tw-saturate:  ;\n  --tw-sepia:  ;\n  --tw-drop-shadow:  ;\n  --tw-backdrop-blur:  ;\n  --tw-backdrop-brightness:  ;\n  --tw-backdrop-contrast:  ;\n  --tw-backdrop-grayscale:  ;\n  --tw-backdrop-hue-rotate:  ;\n  --tw-backdrop-invert:  ;\n  --tw-backdrop-opacity:  ;\n  --tw-backdrop-saturate:  ;\n  --tw-backdrop-sepia:  ;\n  --tw-contain-size:  ;\n  --tw-contain-layout:  ;\n  --tw-contain-paint:  ;\n  --tw-contain-style:  ;\n}/*\n! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com\n*//*\n1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)\n2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)\n*/\n\n*,\n::before,\n::after {\n  box-sizing: border-box; /* 1 */\n  border-width: 0; /* 2 */\n  border-style: solid; /* 2 */\n  border-color: #595959; /* 2 */\n}\n\n::before,\n::after {\n  --tw-content: '';\n}\n\n/*\n1. Use a consistent sensible line-height in all browsers.\n2. Prevent adjustments of font size after orientation changes in iOS.\n3. Use a more readable tab size.\n4. Use the user's configured `sans` font-family by default.\n5. Use the user's configured `sans` font-feature-settings by default.\n6. Use the user's configured `sans` font-variation-settings by default.\n7. Disable tap highlights on iOS\n*/\n\nhtml,\n:host {\n  line-height: 1.5; /* 1 */\n  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */\n  tab-size: 4; /* 3 */\n  font-family: ui-sans-serif, system-ui, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\"; /* 4 */\n  font-feature-settings: normal; /* 5 */\n  font-variation-settings: normal; /* 6 */\n  -webkit-tap-highlight-color: transparent; /* 7 */\n}\n\n/*\n1. Remove the margin in all browsers.\n2. Inherit line-height from `html` so users can set them as a class directly on the `html` element.\n*/\n\nbody {\n  margin: 0; /* 1 */\n  line-height: inherit; /* 2 */\n}\n\n/*\n1. Add the correct height in Firefox.\n2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)\n3. Ensure horizontal rules are visible by default.\n*/\n\nhr {\n  height: 0; /* 1 */\n  color: inherit; /* 2 */\n  border-top-width: 1px; /* 3 */\n}\n\n/*\nAdd the correct text decoration in Chrome, Edge, and Safari.\n*/\n\nabbr:where([title]) {\n  -webkit-text-decoration: underline dotted;\n          text-decoration: underline dotted;\n}\n\n/*\nRemove the default font size and weight for headings.\n*/\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-size: inherit;\n  font-weight: inherit;\n}\n\n/*\nReset links to optimize for opt-in styling instead of opt-out.\n*/\n\na {\n  color: inherit;\n  text-decoration: inherit;\n}\n\n/*\nAdd the correct font weight in Edge and Safari.\n*/\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\n/*\n1. Use the user's configured `mono` font-family by default.\n2. Use the user's configured `mono` font-feature-settings by default.\n3. Use the user's configured `mono` font-variation-settings by default.\n4. Correct the odd `em` font sizing in all browsers.\n*/\n\ncode,\nkbd,\nsamp,\npre {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace; /* 1 */\n  font-feature-settings: normal; /* 2 */\n  font-variation-settings: normal; /* 3 */\n  font-size: 1em; /* 4 */\n}\n\n/*\nAdd the correct font size in all browsers.\n*/\n\nsmall {\n  font-size: 80%;\n}\n\n/*\nPrevent `sub` and `sup` elements from affecting the line height in all browsers.\n*/\n\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\n/*\n1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)\n2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)\n3. Remove gaps between table borders by default.\n*/\n\ntable {\n  text-indent: 0; /* 1 */\n  border-color: inherit; /* 2 */\n  border-collapse: collapse; /* 3 */\n}\n\n/*\n1. Change the font styles in all browsers.\n2. Remove the margin in Firefox and Safari.\n3. Remove default padding in all browsers.\n*/\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font-family: inherit; /* 1 */\n  font-feature-settings: inherit; /* 1 */\n  font-variation-settings: inherit; /* 1 */\n  font-size: 100%; /* 1 */\n  font-weight: inherit; /* 1 */\n  line-height: inherit; /* 1 */\n  letter-spacing: inherit; /* 1 */\n  color: inherit; /* 1 */\n  margin: 0; /* 2 */\n  padding: 0; /* 3 */\n}\n\n/*\nRemove the inheritance of text transform in Edge and Firefox.\n*/\n\nbutton,\nselect {\n  text-transform: none;\n}\n\n/*\n1. Correct the inability to style clickable types in iOS and Safari.\n2. Remove default button styles.\n*/\n\nbutton,\ninput:where([type='button']),\ninput:where([type='reset']),\ninput:where([type='submit']) {\n  -webkit-appearance: button; /* 1 */\n  background-color: transparent; /* 2 */\n  background-image: none; /* 2 */\n}\n\n/*\nUse the modern Firefox focus style for all focusable elements.\n*/\n\n:-moz-focusring {\n  outline: auto;\n}\n\n/*\nRemove the additional `:invalid` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)\n*/\n\n:-moz-ui-invalid {\n  box-shadow: none;\n}\n\n/*\nAdd the correct vertical alignment in Chrome and Firefox.\n*/\n\nprogress {\n  vertical-align: baseline;\n}\n\n/*\nCorrect the cursor style of increment and decrement buttons in Safari.\n*/\n\n::-webkit-inner-spin-button,\n::-webkit-outer-spin-button {\n  height: auto;\n}\n\n/*\n1. Correct the odd appearance in Chrome and Safari.\n2. Correct the outline style in Safari.\n*/\n\n[type='search'] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}\n\n/*\nRemove the inner padding in Chrome and Safari on macOS.\n*/\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n/*\n1. Correct the inability to style clickable types in iOS and Safari.\n2. Change font properties to `inherit` in Safari.\n*/\n\n::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/*\nAdd the correct display in Chrome and Safari.\n*/\n\nsummary {\n  display: list-item;\n}\n\n/*\nRemoves the default spacing and border for appropriate elements.\n*/\n\nblockquote,\ndl,\ndd,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nhr,\nfigure,\np,\npre {\n  margin: 0;\n}\n\nfieldset {\n  margin: 0;\n  padding: 0;\n}\n\nlegend {\n  padding: 0;\n}\n\nol,\nul,\nmenu {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n/*\nReset default styling for dialogs.\n*/\ndialog {\n  padding: 0;\n}\n\n/*\nPrevent resizing textareas horizontally by default.\n*/\n\ntextarea {\n  resize: vertical;\n}\n\n/*\n1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)\n2. Set the default placeholder color to the user's configured gray 400 color.\n*/\n\ninput::placeholder,\ntextarea::placeholder {\n  opacity: 1; /* 1 */\n  color: #9ca3af; /* 2 */\n}\n\n/*\nSet the default cursor for buttons.\n*/\n\nbutton,\n[role=\"button\"] {\n  cursor: pointer;\n}\n\n/*\nMake sure disabled buttons don't get the pointer cursor.\n*/\n:disabled {\n  cursor: default;\n}\n\n/*\n1. Make replaced elements `display: block` by default. (https://github.com/mozdevs/cssremedy/issues/14)\n2. Add `vertical-align: middle` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)\n   This can trigger a poorly considered lint error in some tools but is included by design.\n*/\n\nimg,\nsvg,\nvideo,\ncanvas,\naudio,\niframe,\nembed,\nobject {\n  display: block; /* 1 */\n  vertical-align: middle; /* 2 */\n}\n\n/*\nConstrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)\n*/\n\nimg,\nvideo {\n  max-width: 100%;\n  height: auto;\n}\n\n/* Make elements with the HTML hidden attribute stay hidden by default */\n[hidden]:where(:not([hidden=\"until-found\"])) {\n  display: none;\n}\n\n* {\n  scrollbar-color: initial;\n  scrollbar-width: initial;\n}\n.container {\n  width: 100%;\n}\n@media (min-width: 300px) {\n\n  .container {\n    max-width: 300px;\n  }\n}\n@media (min-width: 400px) {\n\n  .container {\n    max-width: 400px;\n  }\n}\n@media (min-width: 640px) {\n\n  .container {\n    max-width: 640px;\n  }\n}\n@media (min-width: 768px) {\n\n  .container {\n    max-width: 768px;\n  }\n}\n@media (min-width: 1024px) {\n\n  .container {\n    max-width: 1024px;\n  }\n}\n@media (min-width: 1220px) {\n\n  .container {\n    max-width: 1220px;\n  }\n}\n@media (min-width: 1280px) {\n\n  .container {\n    max-width: 1280px;\n  }\n}\n@media (min-width: 1354px) {\n\n  .container {\n    max-width: 1354px;\n  }\n}\n@media (min-width: 1512px) {\n\n  .container {\n    max-width: 1512px;\n  }\n}\n@media (min-width: 1656px) {\n\n  .container {\n    max-width: 1656px;\n  }\n}\n@media (min-width: 1800px) {\n\n  .container {\n    max-width: 1800px;\n  }\n}\n@media (min-width: 1920px) {\n\n  .container {\n    max-width: 1920px;\n  }\n}\n.pointer-events-none {\n  pointer-events: none;\n}\n.visible {\n  visibility: visible;\n}\n.fixed {\n  position: fixed;\n}\n.absolute {\n  position: absolute;\n}\n.relative {\n  position: relative;\n}\n.inset-0 {\n  inset: 0px;\n}\n.-bottom-5 {\n  bottom: -20px;\n}\n.-bottom-6 {\n  bottom: -24px;\n}\n.bottom-0 {\n  bottom: 0px;\n}\n.left-0 {\n  left: 0px;\n}\n.left-20 {\n  left: 136px;\n}\n.right-0 {\n  right: 0px;\n}\n.right-7 {\n  right: 32px;\n}\n.top-0 {\n  top: 0px;\n}\n.top-6 {\n  top: 24px;\n}\n.z-10 {\n  z-index: 10;\n}\n.z-20 {\n  z-index: 20;\n}\n.z-30 {\n  z-index: 30;\n}\n.z-50 {\n  z-index: 50;\n}\n.mx-auto {\n  margin-left: auto;\n  margin-right: auto;\n}\n.-ml-6 {\n  margin-left: -24px;\n}\n.-mr-1 {\n  margin-right: -4px;\n}\n.mb-10 {\n  margin-bottom: 56px;\n}\n.mb-2 {\n  margin-bottom: 8px;\n}\n.mb-4 {\n  margin-bottom: 16px;\n}\n.mb-6 {\n  margin-bottom: 24px;\n}\n.mb-8 {\n  margin-bottom: 40px;\n}\n.ml-1 {\n  margin-left: 4px;\n}\n.ml-2 {\n  margin-left: 8px;\n}\n.ml-\\[15px\\] {\n  margin-left: 15px;\n}\n.mr-2 {\n  margin-right: 8px;\n}\n.mt-0 {\n  margin-top: 0px;\n}\n.mt-1 {\n  margin-top: 4px;\n}\n.mt-14 {\n  margin-top: 88px;\n}\n.mt-2 {\n  margin-top: 8px;\n}\n.mt-4 {\n  margin-top: 16px;\n}\n.mt-5 {\n  margin-top: 20px;\n}\n.inline-block {\n  display: inline-block;\n}\n.flex {\n  display: flex;\n}\n.inline-flex {\n  display: inline-flex;\n}\n.grid {\n  display: grid;\n}\n.hidden {\n  display: none;\n}\n.\\!h-11 {\n  height: 64px !important;\n}\n.h-10 {\n  height: 56px;\n}\n.h-11 {\n  height: 64px;\n}\n.h-5 {\n  height: 20px;\n}\n.h-7 {\n  height: 32px;\n}\n.h-8 {\n  height: 40px;\n}\n.h-\\[296px\\] {\n  height: 296px;\n}\n.h-\\[64px\\] {\n  height: 64px;\n}\n.h-full {\n  height: 100%;\n}\n.max-h-\\[350px\\] {\n  max-height: 350px;\n}\n.max-h-\\[calc\\(100vh-100px\\)\\] {\n  max-height: calc(100vh - 100px);\n}\n.w-16 {\n  width: 104px;\n}\n.w-5 {\n  width: 20px;\n}\n.w-6 {\n  width: 24px;\n}\n.w-7 {\n  width: 32px;\n}\n.w-8 {\n  width: 40px;\n}\n.w-\\[148px\\] {\n  width: 148px;\n}\n.w-\\[20\\%\\] {\n  width: 20%;\n}\n.w-\\[200px\\] {\n  width: 200px;\n}\n.w-\\[272px\\] {\n  width: 272px;\n}\n.w-\\[280px\\] {\n  width: 280px;\n}\n.w-\\[90\\%\\] {\n  width: 90%;\n}\n.w-fit {\n  width: fit-content;\n}\n.w-full {\n  width: 100%;\n}\n.max-w-fit {\n  max-width: fit-content;\n}\n.shrink-0 {\n  flex-shrink: 0;\n}\n.flex-grow {\n  flex-grow: 1;\n}\n.translate-y-0 {\n  --tw-translate-y: 0px;\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n}\n.translate-y-20 {\n  --tw-translate-y: 136px;\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n}\n.rotate-0 {\n  --tw-rotate: 0deg;\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n}\n.rotate-180 {\n  --tw-rotate: 180deg;\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n}\n.transform {\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\n}\n@keyframes spin {\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n.animate-spin {\n  animation: spin 1s linear infinite;\n}\n.cursor-not-allowed {\n  cursor: not-allowed;\n}\n.cursor-pointer {\n  cursor: pointer;\n}\n.grid-cols-1 {\n  grid-template-columns: repeat(1, minmax(0, 1fr));\n}\n.grid-cols-7 {\n  grid-template-columns: repeat(7, minmax(0, 1fr));\n}\n.flex-col {\n  flex-direction: column;\n}\n.flex-wrap {\n  flex-wrap: wrap;\n}\n.items-start {\n  align-items: flex-start;\n}\n.items-end {\n  align-items: flex-end;\n}\n.items-center {\n  align-items: center;\n}\n.justify-start {\n  justify-content: flex-start;\n}\n.justify-end {\n  justify-content: flex-end;\n}\n.justify-center {\n  justify-content: center;\n}\n.justify-between {\n  justify-content: space-between;\n}\n.justify-around {\n  justify-content: space-around;\n}\n.gap-2 {\n  gap: 8px;\n}\n.gap-3 {\n  gap: 12px;\n}\n.gap-4 {\n  gap: 16px;\n}\n.gap-5 {\n  gap: 20px;\n}\n.space-y-11 > :not([hidden]) ~ :not([hidden]) {\n  --tw-space-y-reverse: 0;\n  margin-top: calc(64px * calc(1 - var(--tw-space-y-reverse)));\n  margin-bottom: calc(64px * var(--tw-space-y-reverse));\n}\n.self-center {\n  align-self: center;\n}\n.overflow-auto {\n  overflow: auto;\n}\n.overflow-y-auto {\n  overflow-y: auto;\n}\n.rounded-2xl {\n  border-radius: 1rem;\n}\n.rounded-full {\n  border-radius: 9999px;\n}\n.rounded-lg {\n  border-radius: 0.5rem;\n}\n.rounded-md {\n  border-radius: 0.375rem;\n}\n.rounded-none {\n  border-radius: 0px;\n}\n.rounded-xl {\n  border-radius: 0.75rem;\n}\n.rounded-l-lg {\n  border-top-left-radius: 0.5rem;\n  border-bottom-left-radius: 0.5rem;\n}\n.rounded-l-xl {\n  border-top-left-radius: 0.75rem;\n  border-bottom-left-radius: 0.75rem;\n}\n.rounded-r-lg {\n  border-top-right-radius: 0.5rem;\n  border-bottom-right-radius: 0.5rem;\n}\n.rounded-r-xl {\n  border-top-right-radius: 0.75rem;\n  border-bottom-right-radius: 0.75rem;\n}\n.border {\n  border-width: 1px;\n}\n.border-2 {\n  border-width: 2px;\n}\n.border-y {\n  border-top-width: 1px;\n  border-bottom-width: 1px;\n}\n.border-b {\n  border-bottom-width: 1px;\n}\n.border-none {\n  border-style: none;\n}\n.border-\\[\\#999999\\] {\n  --tw-border-opacity: 1;\n  border-color: rgb(153 153 153 / var(--tw-border-opacity, 1));\n}\n.border-\\[\\#ff7020\\] {\n  --tw-border-opacity: 1;\n  border-color: rgb(255 112 32 / var(--tw-border-opacity, 1));\n}\n.border-gray {\n  --tw-border-opacity: 1;\n  border-color: rgb(154 145 135 / var(--tw-border-opacity, 1));\n}\n.border-gray-10 {\n  --tw-border-opacity: 1;\n  border-color: rgb(231 232 232 / var(--tw-border-opacity, 1));\n}\n.border-gray-20 {\n  --tw-border-opacity: 1;\n  border-color: rgb(208 209 210 / var(--tw-border-opacity, 1));\n}\n.border-orange-600 {\n  --tw-border-opacity: 1;\n  border-color: rgb(234 88 12 / var(--tw-border-opacity, 1));\n}\n.border-red-500 {\n  --tw-border-opacity: 1;\n  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));\n}\n.border-transparent {\n  border-color: transparent;\n}\n.\\!bg-\\[\\#F2F2F2\\] {\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(242 242 242 / var(--tw-bg-opacity, 1)) !important;\n}\n.\\!bg-\\[\\#ff7020\\] {\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(255 112 32 / var(--tw-bg-opacity, 1)) !important;\n}\n.bg-\\[\\#000\\] {\n  --tw-bg-opacity: 1;\n  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));\n}\n.bg-\\[\\#FFF0CC\\] {\n  --tw-bg-opacity: 1;\n  background-color: rgb(255 240 204 / var(--tw-bg-opacity, 1));\n}\n.bg-\\[\\#ded7d3\\] {\n  --tw-bg-opacity: 1;\n  background-color: rgb(222 215 211 / var(--tw-bg-opacity, 1));\n}\n.bg-\\[\\#f2f2f2\\] {\n  --tw-bg-opacity: 1;\n  background-color: rgb(242 242 242 / var(--tw-bg-opacity, 1));\n}\n.bg-\\[\\#ff7020\\] {\n  --tw-bg-opacity: 1;\n  background-color: rgb(255 112 32 / var(--tw-bg-opacity, 1));\n}\n.bg-black {\n  --tw-bg-opacity: 1;\n  background-color: rgb(30 30 30 / var(--tw-bg-opacity, 1));\n}\n.bg-orange-600 {\n  --tw-bg-opacity: 1;\n  background-color: rgb(234 88 12 / var(--tw-bg-opacity, 1));\n}\n.bg-white {\n  --tw-bg-opacity: 1;\n  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));\n}\n.bg-opacity-50 {\n  --tw-bg-opacity: 0.5;\n}\n.fill-black {\n  fill: #1E1E1E;\n}\n.p-1 {\n  padding: 4px;\n}\n.p-2 {\n  padding: 8px;\n}\n.p-3 {\n  padding: 12px;\n}\n.p-4 {\n  padding: 16px;\n}\n.p-6 {\n  padding: 24px;\n}\n.px-4 {\n  padding-left: 16px;\n  padding-right: 16px;\n}\n.px-7 {\n  padding-left: 32px;\n  padding-right: 32px;\n}\n.py-1 {\n  padding-top: 4px;\n  padding-bottom: 4px;\n}\n.py-2 {\n  padding-top: 8px;\n  padding-bottom: 8px;\n}\n.py-3 {\n  padding-top: 12px;\n  padding-bottom: 12px;\n}\n.py-6 {\n  padding-top: 24px;\n  padding-bottom: 24px;\n}\n.pt-\\[20\\%\\] {\n  padding-top: 20%;\n}\n.pt-\\[5\\%\\] {\n  padding-top: 5%;\n}\n.text-left {\n  text-align: left;\n}\n.text-center {\n  text-align: center;\n}\n.text-\\[12px\\] {\n  font-size: 12px;\n}\n.text-\\[14px\\] {\n  font-size: 14px;\n}\n.text-\\[16px\\] {\n  font-size: 16px;\n}\n.text-\\[24px\\] {\n  font-size: 24px;\n}\n.font-bold {\n  font-weight: 700;\n}\n.font-medium {\n  font-weight: 500;\n}\n.font-normal {\n  font-weight: 400;\n}\n.font-semibold {\n  font-weight: 600;\n}\n.\\!text-black {\n  --tw-text-opacity: 1 !important;\n  color: rgb(30 30 30 / var(--tw-text-opacity, 1)) !important;\n}\n.text-\\[\\#595959\\] {\n  --tw-text-opacity: 1;\n  color: rgb(89 89 89 / var(--tw-text-opacity, 1));\n}\n.text-\\[\\#666666\\] {\n  --tw-text-opacity: 1;\n  color: rgb(102 102 102 / var(--tw-text-opacity, 1));\n}\n.text-\\[\\#7C3A00\\] {\n  --tw-text-opacity: 1;\n  color: rgb(124 58 0 / var(--tw-text-opacity, 1));\n}\n.text-\\[\\#999\\] {\n  --tw-text-opacity: 1;\n  color: rgb(153 153 153 / var(--tw-text-opacity, 1));\n}\n.text-\\[\\#ff7020\\] {\n  --tw-text-opacity: 1;\n  color: rgb(255 112 32 / var(--tw-text-opacity, 1));\n}\n.text-black {\n  --tw-text-opacity: 1;\n  color: rgb(30 30 30 / var(--tw-text-opacity, 1));\n}\n.text-gray-500 {\n  --tw-text-opacity: 1;\n  color: rgb(107 114 128 / var(--tw-text-opacity, 1));\n}\n.text-gray-600 {\n  --tw-text-opacity: 1;\n  color: rgb(75 85 99 / var(--tw-text-opacity, 1));\n}\n.text-orange-600 {\n  --tw-text-opacity: 1;\n  color: rgb(234 88 12 / var(--tw-text-opacity, 1));\n}\n.text-red-500 {\n  --tw-text-opacity: 1;\n  color: rgb(239 68 68 / var(--tw-text-opacity, 1));\n}\n.text-white {\n  --tw-text-opacity: 1;\n  color: rgb(255 255 255 / var(--tw-text-opacity, 1));\n}\n.line-through {\n  text-decoration-line: line-through;\n}\n.opacity-0 {\n  opacity: 0;\n}\n.opacity-100 {\n  opacity: 1;\n}\n.shadow-2xl {\n  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);\n  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\n}\n.shadow-lg {\n  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);\n  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\n}\n.shadow-xl {\n  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);\n  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\n}\n.outline-none {\n  outline: 2px solid transparent;\n  outline-offset: 2px;\n}\n.filter {\n  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);\n}\n.transition-all {\n  transition-property: all;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 150ms;\n}\n.transition-opacity {\n  transition-property: opacity;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 150ms;\n}\n.transition-shadow {\n  transition-property: box-shadow;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 150ms;\n}\n.transition-transform {\n  transition-property: transform;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 150ms;\n}\n.duration-200 {\n  transition-duration: 200ms;\n}\n.duration-300 {\n  transition-duration: 300ms;\n}\n.ease-in-out {\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n}\n.scrollbar-hide {\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n.scrollbar-hide::-webkit-scrollbar {\n  display: none;\n}\n.scrollbar-thin::-webkit-scrollbar-track {\n  background-color: var(--scrollbar-track);\n  border-radius: var(--scrollbar-track-radius);\n}\n.scrollbar-thin::-webkit-scrollbar-track:hover {\n  background-color: var(--scrollbar-track-hover, var(--scrollbar-track));\n}\n.scrollbar-thin::-webkit-scrollbar-track:active {\n  background-color: var(--scrollbar-track-active, var(--scrollbar-track-hover, var(--scrollbar-track)));\n}\n.scrollbar-thin::-webkit-scrollbar-thumb {\n  background-color: var(--scrollbar-thumb);\n  border-radius: var(--scrollbar-thumb-radius);\n}\n.scrollbar-thin::-webkit-scrollbar-thumb:hover {\n  background-color: var(--scrollbar-thumb-hover, var(--scrollbar-thumb));\n}\n.scrollbar-thin::-webkit-scrollbar-thumb:active {\n  background-color: var(--scrollbar-thumb-active, var(--scrollbar-thumb-hover, var(--scrollbar-thumb)));\n}\n.scrollbar-thin::-webkit-scrollbar-corner {\n  background-color: var(--scrollbar-corner);\n  border-radius: var(--scrollbar-corner-radius);\n}\n.scrollbar-thin::-webkit-scrollbar-corner:hover {\n  background-color: var(--scrollbar-corner-hover, var(--scrollbar-corner));\n}\n.scrollbar-thin::-webkit-scrollbar-corner:active {\n  background-color: var(--scrollbar-corner-active, var(--scrollbar-corner-hover, var(--scrollbar-corner)));\n}\n.scrollbar-thin {\n  scrollbar-width: thin;\n  scrollbar-color: var(--scrollbar-thumb, initial) var(--scrollbar-track, initial);\n}\n.scrollbar-thin::-webkit-scrollbar {\n  display: block;\n  width: 8px;\n  height: 8px;\n}\n.scrollbar-track-white {\n  --scrollbar-track: #FFFFFF !important;\n}\n.scrollbar-thumb-black {\n  --scrollbar-thumb: #1E1E1E !important;\n}\n.placeholder\\:font-semibold::placeholder {\n  font-weight: 600;\n}\n.placeholder\\:text-\\[\\#59595959\\]::placeholder {\n  color: #59595959;\n}\n.placeholder\\:text-black::placeholder {\n  --tw-text-opacity: 1;\n  color: rgb(30 30 30 / var(--tw-text-opacity, 1));\n}\n.hover\\:border:hover {\n  border-width: 1px;\n}\n.hover\\:border-orange-600:hover {\n  --tw-border-opacity: 1;\n  border-color: rgb(234 88 12 / var(--tw-border-opacity, 1));\n}\n.hover\\:border-orange-700:hover {\n  --tw-border-opacity: 1;\n  border-color: rgb(194 65 12 / var(--tw-border-opacity, 1));\n}\n.hover\\:bg-gray-100:hover {\n  --tw-bg-opacity: 1;\n  background-color: rgb(218 208 197 / var(--tw-bg-opacity, 1));\n}\n.hover\\:bg-gray-50:hover {\n  --tw-bg-opacity: 1;\n  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));\n}\n.focus\\:border-orange-500:focus {\n  --tw-border-opacity: 1;\n  border-color: rgb(249 115 22 / var(--tw-border-opacity, 1));\n}\n.focus\\:outline-none:focus {\n  outline: 2px solid transparent;\n  outline-offset: 2px;\n}\n.active\\:border:active {\n  border-width: 1px;\n}\n.active\\:bg-black:active {\n  --tw-bg-opacity: 1;\n  background-color: rgb(30 30 30 / var(--tw-bg-opacity, 1));\n}\n.active\\:text-white:active {\n  --tw-text-opacity: 1;\n  color: rgb(255 255 255 / var(--tw-text-opacity, 1));\n}\n.disabled\\:bg-\\[\\#F2F2F2\\]:disabled {\n  --tw-bg-opacity: 1;\n  background-color: rgb(242 242 242 / var(--tw-bg-opacity, 1));\n}\n.disabled\\:bg-gray:disabled {\n  --tw-bg-opacity: 1;\n  background-color: rgb(154 145 135 / var(--tw-bg-opacity, 1));\n}\n@media (min-width: 640px) {\n\n  .sm\\:flex-col {\n    flex-direction: column;\n  }\n\n  .sm\\:self-end {\n    align-self: flex-end;\n  }\n}\n@media (min-width: 768px) {\n\n  .md\\:ml-7 {\n    margin-left: 32px;\n  }\n}\n@media (min-width: 1024px) {\n\n  .lg\\:flex-row {\n    flex-direction: row;\n  }\n\n  .lg\\:self-center {\n    align-self: center;\n  }\n}\n@media (min-width: 1280px) {\n\n  .xl\\:ml-0 {\n    margin-left: 0px;\n  }\n}\n\n/* Estilos para .ant-select */\n.ant-select-selector {\n  width: 270px;\n  height: 64px;\n  transition: border-color 0.3s;\n  border-radius: 8px;\n  border: 1.5px solid #999999 !important;\n  box-shadow: none;\n  outline: none;\n}\n\n.ant-select-selector:hover {\n  border: 1.5px solid #EA580C !important;\n}\n\n.ant-select-selector:focus-within {\n  border: 1.5px solid #EA580C !important;\n}\n\n.ant-select-status-error .ant-select-selector {\n  border: 2px solid red !important;\n}\n\n/* Estilos para .ant-picker */\n.ant-picker.ant-picker-outlined.css-dev-only-do-not-override-apn68.ant-picker {\n  border: 2px solid transparent !important;\n  height: 64px !important;\n  width: auto;\n  border-radius: 8px !important;\n  transition: border-color 0.3s;\n  outline: none;\n}\n\n.ant-picker.ant-picker-range.ant-picker-outlined.css-dev-only-do-not-override-apn68 .ant-picker {\n  border: transparent !important;\n  outline: none;\n}\n\n.ant-picker.ant-picker-range.ant-picker-outlined.css-dev-only-do-not-override-apn68.ant-picker:focus-within {\n  border: transparent !important;\n  outline: none;\n}\n\n.ant-picker.ant-picker-rangeant-picker-outlined.css-dev-only-do-not-override-apn68.ant-picker:hover,\n.ant-select-selector:focus,\n.ant-picker.ant-picker-outlined.css-dev-only-do-not-override-apn68.ant-picker:focus {\n  border: 2px solid #EA580C !important;\n}\n\n.ant-picker-range-separator .anticon-swap-right svg {\n  display: none !important;\n}\n\n.ant-picker-active-bar {\n  display: none;\n}\n\n/* Estilos para .ant-picker com erro */\n.ant-picker-status-error {\n  border-color: red !important;\n}\n\n/* Estilos para o botão de pesquisa personalizado */\n.custom-search-button {\n  background-color: #EA580C;\n  color: white;\n  height: 48px;\n  padding: 0 16px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.3s;\n}\n\n.custom-search-button:hover {\n  background-color: #cc4c0a;\n}\n\n/* Estilos de células do calendário */\n.ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner,\n.ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner {\n  background-color: #000000 !important;\n  width: 39px;\n  height: 38px;\n  border-radius: 14px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.ant-picker-cell-in-view.ant-picker-cell-today .ant-picker-cell-inner::before {\n  border-color: #EA580C !important;\n  border-radius: 14px !important;\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n  text-align: center !important;\n}\n\n.ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single)::before,\n.ant-picker-cell-in-view.ant-picker-cell-in-range::before,\n.ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single)::before {\n  background: rgb(245, 245, 245) !important;\n  width: 40px;\n  height: 38px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n/* Estilos para o painel de hora */\n.ant-picker-time-panel-column li.ant-picker-time-panel-cell-selected .ant-picker-time-panel-cell-inner {\n  background: rgb(245, 245, 245) !important;\n  width: 40px;\n  height: 38px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n/* Estilos para o campo de entrada de data */\n\n.custom-rangepicker .ant-picker-input {\n  border: 2.5px solid #999999;\n  border-radius: 8px;\n  height: 66px;\n  width: 160px !important;\n  padding: 20px;\n  transition: border-color 0.3s ease;\n}\n\n.custom-rangepicker.error .ant-picker-input {\n  border-color: #ef4444 !important; /* Cor da borda em caso de erro */\n}\n\n\n@media (max-width: 1024px) {\n  .ant-picker-input {\n    width: 270px !important;\n    margin-left: -15px;\n  }\n}\n\n.ant-picker-input:hover {\n  border: 2.5px solid #EA580C !important;\n}\n\n.ant-picker-input:hover:where(.css-dev-only-do-not-override-apn68).ant-picker-outlined:focus,\n:where(.css-dev-only-do-not-override-1x0dypw).ant-picker-outlined:focus, :where(.css-dev-only-do-not-override-1x0dypw).ant-picker-outlined:focus-within {\n  border-color: transparent !important;\n  box-shadow: none !important;\n}\n:where(.css-dev-only-do-not-override-apn68).ant-picker-outlined:focus-within {\n  box-shadow: none !important;\n  border: 2.5px solid #EA580C !important;\n}\n\n.ant-select-selection-placeholder,\n.ant-picker-input input::placeholder {\n  color: #6B7280 !important;\n}\n\n.ant-picker .ant-picker-range .ant-picker-outlined .css-dev-only-do-not-override-apn68 .ant-picker {\n  border: 2px solid transparent !important;\n  outline: none;\n}\n\n.ant-picker.ant-picker-range.ant-picker-outlined.css-dev-only-do-not-override-apn68.ant-picker:focus-within {\n  border: 2px solid transparent !important;\n  outline: none;\n}\n\n:where(.css-dev-only-do-not-override-1x0dypw).ant-picker-range .ant-picker-range-separator {\n  padding: 0px 0px;\n}\n\n:where(.css-dev-only-do-not-override-1wwf28x).ant-picker-range .ant-picker-range-separator{\n  padding: 0px 0px;\n}\n\n:where(.css-dev-only-do-not-override-1wwf28x).ant-picker-outlined:focus, :where(.css-dev-only-do-not-override-1wwf28x).ant-picker-outlined:focus-within {\n  box-shadow: none !important;\n}\n.ant-picker-range-separator .anticon-swap-right svg {\n  display: none !important;\n  padding: 0px 0px;\n}\n\n:where(.css-dev-only-do-not-override-tpassh).ant-picker-range .ant-picker-range-separator{\n  padding: 0px 0px;\n  width: 10px;\n  @media (max-width: 1024px) {\n    padding: 0px 6px;\n  }\n}\n\n.ant-picker-active-bar {\n  display: none;\n}\n\n.ant-picker .ant-picker-range .ant-picker-outlined .css-dev-only-do-not-override-apn68 .ant-picker {\n  border: none !important;\n  outline: none;\n}\n\n/* Estilos para a entrada de data com erro */\n.ant-picker-status-error {\n  border-color: red !important;\n}\n\ndiv[class*=\"ant-picker-range\"] {\n  background: transparent;\n  border-width: 0;\n  border-color: transparent;\n\n  @media (max-width: 1024px) {\n    margin-left: 3px;\n    gap: 10px;\n  }\n}\n\n:where(.css-dev-only-do-not-override-tpassh).ant-picker-outlined:focus,\n:where(.css-dev-only-do-not-override-tpassh).ant-picker-outlined:focus-within {\n  background-color: transparent;\n  border-color: transparent;\n  box-shadow: 0 0 2px rgba(255, 255, 255, 0.5);\n  outline: 0;\n}\n:where(.css-dev-only-do-not-override-1wwf28x).ant-select-dropdown .ant-select-item {\n  height: 50px !important;\n  cursor: pointer !important;\n}\n\nbutton.disabled{\n  cursor: not-allowed !important;\n  color: gray;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
